/**
 * RevenueForecastChart — Best / Expected / Worst stacked area chart.
 * Consumes `expectedAnnualRevenue` from GET /predictions/revenue-forecast.
 */
import React from 'react';
import {
  ResponsiveContainer, AreaChart, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, Area,
} from 'recharts';

const fmt = (v) => v >= 1e7 ? `₹${(v / 1e7).toFixed(1)} Cr`
                  : v >= 1e5 ? `₹${(v / 1e5).toFixed(1)} L`
                             : `₹${(v || 0).toFixed(0)}`;

const RevenueForecastChart = ({ data = [] }) => (
  <div className="w-full h-72" data-testid="revenue-forecast-chart">
    <ResponsiveContainer>
      <AreaChart data={data} margin={{ top: 10, right: 20, bottom: 10, left: 10 }}>
        <defs>
          <linearGradient id="best" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#10B981" stopOpacity={0.35} />
            <stop offset="95%" stopColor="#10B981" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="exp" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#3B82F6" stopOpacity={0.55} />
            <stop offset="95%" stopColor="#3B82F6" stopOpacity={0.05} />
          </linearGradient>
          <linearGradient id="wst" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#F59E0B" stopOpacity={0.35} />
            <stop offset="95%" stopColor="#F59E0B" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#1F2937" />
        <XAxis dataKey="year" stroke="#94A3B8" fontSize={11} />
        <YAxis stroke="#94A3B8" fontSize={11} tickFormatter={fmt} width={70} />
        <Tooltip
          contentStyle={{ backgroundColor: '#0F1923', border: '1px solid #1E4E8C', borderRadius: 6 }}
          labelStyle={{ color: '#F1F5F9' }}
          formatter={(v) => fmt(v)}
        />
        <Legend wrapperStyle={{ fontSize: 11 }} />
        <Area type="monotone" dataKey="bestCaseRevenue" stroke="#10B981" fill="url(#best)" name="Best Case" />
        <Area type="monotone" dataKey="expectedRevenue" stroke="#3B82F6" fill="url(#exp)" name="Expected" />
        <Area type="monotone" dataKey="worstCaseRevenue" stroke="#F59E0B" fill="url(#wst)" name="Worst Case" />
      </AreaChart>
    </ResponsiveContainer>
  </div>
);

export default RevenueForecastChart;
